import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { z, ZodType } from 'zod'

import {
  PcrPayScaleTypeEnum,
  pcrPayScaleTypeMapping
} from '../../../lib/types/enums/pcr-pay-scales/pcr-pay-scale-type.enum'
import { PcrPayScaleInput } from '../../../lib/types/models/pcr-pay-scales/pcr-pay-scale-input'
import { BaseFormProps } from '../../../lib/types/utils'
import { getSubmitAction } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { getSelectedOption } from '../../../lib/utils/functions/misc.functions'
import { createEnumSchema } from '../../../lib/utils/validations/enum-validation'
import { createNumberSchema } from '../../../lib/utils/validations/int-array-validation'
import { FORM_MODE } from '../../../utils/constants/form.constants'
import { Form, FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledInput from '../../elements/inputs/controlled-input'
import ControlledSelectInput from '../../elements/inputs/controlled-select-input'
import ValidationButtons from '../../elements/validation-buttons'

const formSchema: ZodType<PcrPayScaleInput> = z.object({
  type: createEnumSchema({
    fieldName: 'type de paiement',
    enumType: PcrPayScaleTypeEnum
  }),
  amount: createNumberSchema('montant', { isPositive: true })
})

export const PcrPayScaleForm = ({
  defaultValues,
  ...validationButtonProps
}: BaseFormProps<PcrPayScaleInput>) => {
  const form = useForm<PcrPayScaleInput>({
    resolver: zodResolver(formSchema),
    defaultValues,
    mode: FORM_MODE
  })

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(getSubmitAction(validationButtonProps.buttonsConfig))}>
        <div className={'flex flex-col gap-4'}>
          <FormField
            control={form.control}
            name={'type'}
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledSelectInput
                    {...field}
                    required
                    label="Type de paiement"
                    options={Object.values(PcrPayScaleTypeEnum).map((value) => ({
                      label: pcrPayScaleTypeMapping[value],
                      value
                    }))}
                    selectedOption={getSelectedOption(
                      field.value,
                      pcrPayScaleTypeMapping[field.value]
                    )}
                  />
                </FormControl>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name={'amount'}
            render={({ field }) => (
              <FormItem className="flex-1">
                <FormControl>
                  <ControlledInput {...field} type="number" label="Montant" required />
                </FormControl>
              </FormItem>
            )}
          />
        </div>
        <ValidationButtons {...validationButtonProps} />
      </form>
    </Form>
  )
}
